module.exports = __webpack_public_path__ + "static/media/lamer-white.d92de83b.png";